import { Component, inject } from "@angular/core";
import { MatTreeModule } from "@angular/material/tree";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { RouterModule, Router, IsActiveMatchOptions } from "@angular/router";
import { MatExpansionModule } from "@angular/material/expansion";

interface NavItem {
  name: string;
  icon: string;
  route?: string;
  heading?: boolean;
  children?:  NavItem[];
}

const NAV_ITEMS: NavItem[] = [
  { name: "Overview", icon: "dashboard", route: "/overview/dashboard" },
  {
    name: "Build",
    icon: "hub",
    children: [
      { name: "Patient Agents", icon: "medical_services", route: "/build/patient-agents" },
      { name: "Domain Agents", icon: "psychology", route: "/build/domain-agents" },
      { name: "Tools", icon: "build", route: "/build/tools" },
      { name: "RAG Corpora", icon: "library_books", route: "/build/rag-corpora" },
    ],
  },
  {
    name: "Simulate",
    icon: "forum",
    children: [
      { name: "Patient Agent Simulator", icon: "forum", route: "/simulate/patient-agent-simulator" },
      { name: "Chat Simulator", icon: "forum", route: "/simulate/chat-simulator" },
    ],
  },
  {
    name: "Release",
    icon: "rocket_launch",
    children: [
      { name: "Agent Release Pipeline", icon: "inventory_2", route: "/release/candidates" },
      { name: "Release Scorecard", icon: "verified", route: "/release/scorecard" },
      { name: "Approvals", icon: "how_to_reg", route: "/release/approvals" },
    ],
  },
  {
    name: "Evaluate",
    icon: "fact_check",
    children: [
      { name: "Test Suites", icon: "fact_check", route: "/evaluate/test-suites" },
      { name: "Golden Datasets", icon: "dataset", route: "/evaluate/golden-datasets" },
      { name: "Expert Review", icon: "rate_review", route: "/evaluate/expert-review" },
    ],
  },
  {
    name: "Observe",
    icon: "monitor_heart",
    children: [
      { name: "Live Activity", icon: "bolt", route: "/observe/live" },
      { name: "Health", icon: "query_stats", route: "/observe/health" },
    ],
  },
  {
    name: "Admin",
    icon: "admin_panel_settings",
    children: [
      { name: "Services & API Keys", icon: "vpn_key", route: "/admin/services-and-api-keys" },
      { name: "Audit Log", icon: "history", route: "/admin/audit-logs" },
      { name: "Users & Roles", icon: "group", route: "/admin/users-and-roles" },
      { name: "Legacy Management", icon: "tune", route: "/admin/legacy-management" },
      { name: "Classification", icon: "", heading: true },
      { name: "LLM Categories", icon: "category", route: "/admin/llm-categories" },
      { name: "Semantic Topics", icon: "hub", route: "/admin/semantic-topics" },
    ],
  },
];

const ACTIVE_OPTIONS: IsActiveMatchOptions = {
  paths: "subset",
  queryParams: "ignored",
  fragment: "ignored",
  matrixParams: "ignored",
};

@Component({
  selector: "app-side-nav",
  standalone: true,
  imports: [
    CommonModule,
    MatTreeModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
    MatExpansionModule
  ],
  templateUrl: "./app-side-nav.component.html",
  styleUrl: "./app-side-nav.component.scss",
})
export class AppSideNavComponent {
  readonly items = NAV_ITEMS;
  private readonly router = inject(Router);

  isExpanded(item: NavItem) {
    return !!item.children?.some((child) => !!child.route && this.router.isActive(child.route, ACTIVE_OPTIONS));
  }
}
